import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-deck" }
const _hoisted_2 = { class: "extra-card-content" }
const _hoisted_3 = { class: "main-card-container" }
const _hoisted_4 = { class: "main-card-content" }
const _hoisted_5 = { class: "quantity-indicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.max(0, _ctx.quantity - 1), (i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "extra-card-container",
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "extra-card", _normalizeProps(_guardReactiveProps({ index: i })), () => [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.quantity), 1)
    ])
  ]))
}